import { AuthConstantS } from '@/features/Auth/outbound/share';
import { CertificationTypeS } from '@/features/Certification/outbound/share';
import { T } from '@/libs/translation';
import { toLowerCase } from '@/libs/util/toLowerCase';
import { LoginPageBodyView } from '@/ui//component/page/LoginPage/LoginPage';
import { Icon, Radio, Typo } from '@/ui/component/atom';
import { ModalBodyView } from '@/ui/component/cell';
import { filter, keys, map, pipe, toArray } from '@fxts/core';
import { html, rune } from 'rune-ts';
import klass from './FindIdResult.module.scss';

export interface FindIdResultViewData extends CertificationTypeS.FindEmailControllerResBodyType {}

export class FindIdResultView extends ModalBodyView<FindIdResultViewData> {
  override template() {
    return html`
      <div class="${klass.container}">
        <div class="${klass.text}">
          ${new Typo({ text: T('auth.find_id.result_title') }, { weight: 'bold' })}
          ${new Typo({ text: T('auth.find_id.result_guide') })}
        </div>
        <div class="${klass.radios}">
          ${this.data.user_data.map(
            (user, index) =>
              new Radio({
                name: 'email',
                label: html`
                  <div class="${klass.radio}">
                    ${new Typo({ text: user.email })}
                    <div class="${klass.sns}">
                      ${pipe(
                        AuthConstantS.USER_LOGIN_SNS_TYPE_MAPPER,
                        keys,
                        filter((sns) => user.sns_types.includes(sns)),
                        map((sns) => new Icon({ name: `${toLowerCase(sns)}_logo`, size: 20 })),
                        toArray,
                      )}
                    </div>
                  </div>
                `,
                value: user.email,
                active: index === 0,
              }),
          )}
        </div>
      </div>
    `;
  }

  override async confirm() {
    await this.findEmailResult();
    return true;
  }

  async findEmailResult() {
    const login_page_body$ = document.querySelector(`.${LoginPageBodyView}`);
    if (!login_page_body$) return;

    const login_page_body = rune.getView(login_page_body$, LoginPageBodyView);
    if (!login_page_body) return;

    const selected_email = this.subViews(Radio)
      .find((radio) => radio.isChecked())
      ?.getValue();

    if (selected_email) {
      const user = this.data.user_data.find((user) => user.email === selected_email);
      if (user?.has_password) {
        login_page_body.component.email.value = selected_email;
      }
    }
  }
}
